import { useTranslation } from "react-i18next";
import Logo from "./Logo";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="mt-20">
      <div className="bg-allsafe-dark-grey px-3.5 pt-16 pb-6 lg:pt-20">
        <div className="max-w-screen-xl mx-auto">
          <div className="w-[169.594px] h-[72px]">
            <Logo />
          </div>
          <hr className=" text-allsafe-grey opacity-75 my-6" />
          <div className="flex items-center justify-between gap-x-8 gap-y-10 flex-wrap md:gap-y-0">
            <ul className="p-0 m-0 flex flex-wrap gap-x-4 max-w-max">
              <li>
                <a
                  className="text-gray-200 underline decoration-text-gray-200 text-base leading-6 font-Roboto font-light decoration-2"
                  href="https://www.allsafe24.com/datenschutzerklaerung"
                  target="_blank"
                  rel="noreferrer"
                >
                  {t("Datenschutzerklärung")}
                </a>
              </li>
              <li>
                <a
                  className="text-gray-200 underline decoration-text-gray-200 text-base leading-6 font-Roboto font-light decoration-2"
                  href="https://www.allsafe24.com/datenschutzerklaerung#cookie-settings"
                  target="_blank"
                  rel="noreferrer"
                >
                  {t("Cookie-Einstellungen")}
                </a>
              </li>
              <li>
                <a
                  className="text-gray-200 underline decoration-text-gray-200 text-base leading-6 font-Roboto font-light decoration-2"
                  href="https://www.allsafe24.com/impressum"
                  target="_blank"
                  rel="noreferrer"
                >
                  {t("Impressum")}
                </a>
              </li>
              <li>
                <a
                  className="text-gray-200 underline decoration-text-gray-200 text-base leading-6 font-Roboto font-light decoration-2"
                  href="https://www.allsafe24.com/avb"
                  target="_blank"
                  rel="noreferrer"
                >
									AVB
                </a>
              </li>
            </ul>
            <p className="text-[#f0f1f4] text-base leading-6 font-Roboto font-light opacity-75">
							© 2023 allsafe GmbH & Co. KG
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
